import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SafeAny } from '@swissfex/sfx-commons';
import { NEVER, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorHandlerService } from './error-handler.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private errorHandlerSvc = inject(ErrorHandlerService);

    public intercept(request: HttpRequest<SafeAny>, next: HttpHandler) {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                const shouldRethrowError = this.errorHandlerSvc.handleError(request, error);

                if (shouldRethrowError) {
                    return throwError(() => error);
                }

                return NEVER;
            })
        );
    }
}
